import React, { FunctionComponent } from 'react';
import {
    Typography,
    Grid,
    TextField,
    ThemeProvider,
    Accordion,
    AccordionDetails,
    AccordionSummary,
} from '@material-ui/core';
import styles, { referralTranslationSummaryTheme } from './ReferralTranslationSummary.Styles';
import { EmptyDataLabel } from '../../../../generic-components/empty-data-label/EmptyDataLabel.Component';
import Moment from 'moment';
import AppointmentTypeEntity from '../../../../../entities/AppointmentType.Entity';
import InterpretationTypeEntity from '../../../../../entities/InterpretationType.Entity';
import TranslationDataModel from '../../../../../data-models/Translation.DataModel';
import LanguageEntity from '../../../../../entities/Language.Entity';
import { TT_AUTHORIZATION_NOTES_LABEL } from '../../../referral-add/referral-service/TtServiceConstants';

interface IReferralTranslationSummaryProps {
    translationService: TranslationDataModel;
    appointmentTypes: Array<AppointmentTypeEntity>;
    interpretationTypes: Array<InterpretationTypeEntity>;
    languages: Array<LanguageEntity>;
}

const SHOW_LEGACY_TRANSLATION_INFO_FIELDS = false;

export const ReferralTranslationSummary: FunctionComponent<IReferralTranslationSummaryProps> = (
    props: IReferralTranslationSummaryProps,
) => {
    const classes = styles();
    const translation = props.translationService?.serviceTypeRequestTranslation;

    return (
        <Accordion defaultExpanded={true} className={classes.paper} square>
            <AccordionSummary aria-controls="panel1a-content" id="cliam-accordion" className={classes.paperHeader}>
                <Typography variant="subtitle2" className={classes.paperTitle}>
                    Translation
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                {props.translationService ? (
                    <Grid container spacing={3} className={classes.gridContainer}>
                        <Grid xs={12} item container>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>
                                    Appointment Type
                                </Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>
                                    {translation?.appointmentTypeId
                                        ? props.appointmentTypes?.find(
                                              (x) => x.appointmentTypeId === translation.appointmentTypeId,
                                          )?.appointmentTypeName ?? '-'
                                        : '-'}
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>
                                    Other Appointment Type
                                </Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>
                                    {translation?.otherAppointmentType ? translation.otherAppointmentType : '-'}
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>
                                    Appointment Date
                                </Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>
                                    {Moment(translation?.appointmentDate).format('MM/DD/YYYY')}
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>
                                    Frequency and Duration
                                </Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>
                                    {translation?.frequencyAndDuration ? translation.frequencyAndDuration : ''}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid xs={12} item container>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>
                                    Language
                                </Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>
                                    {translation?.languageId === 0
                                        ? 'Other'
                                        : props.languages?.find((x) => x.languageId === translation?.languageId)
                                              ?.languageName ?? 'Other'}
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>
                                    Other Language
                                </Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>
                                    {translation?.languageId === 0 && translation?.otherLanguage
                                        ? translation.otherLanguage
                                        : '-'}
                                </Typography>
                            </Grid>
                        </Grid>
                        {SHOW_LEGACY_TRANSLATION_INFO_FIELDS && (
                            <Grid xs={12} item container>
                                <Grid item xs={2}>
                                    <Typography variant="body2" className={classes.dataLabel}>
                                        Interpretation Type
                                    </Typography>
                                    <Typography variant="subtitle2" className={classes.blackFont}>
                                        {translation?.interpretationTypeId
                                            ? props.interpretationTypes?.find(
                                                  (x) =>
                                                      x.interpretationTypeId === translation.interpretationTypeId,
                                              )?.interpretationTypeName ?? '-'
                                            : '-'}
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}
                        <Grid xs={12} item container>
                            <ThemeProvider theme={referralTranslationSummaryTheme}>
                                <TextField
                                    className={classes.summaryTextArea}
                                    multiline
                                    disabled
                                    label={TT_AUTHORIZATION_NOTES_LABEL}
                                    id="specialInstructions"
                                    defaultValue={
                                        translation?.specialInstructions ? translation.specialInstructions : ''
                                    }
                                />
                            </ThemeProvider>
                        </Grid>
                    </Grid>
                ) : (
                    <EmptyDataLabel></EmptyDataLabel>
                )}
            </AccordionDetails>
        </Accordion>
    );
};
